<template>
  <section class="card">
    <div v-if="!loading" class="grafico-novo">
      <div class="wrap-graphic-channel">
        <div class="wrap-control-graphic">
            <div class="controls">
              <a @click="periode= 0" :class="{'active-control': periode == 0}">Semanal</a>
              <a @click="periode= 1" :class="{'active-control': periode == 1}">Mensal</a>
              <a @click="periode= 2" :class="{'active-control': periode == 2}">Anual</a>
            </div>
            <highcharts
              class="highcharts"
              :options="chartOptions"
            />
        </div>
        <ChannelServiceTime/>
      </div>
      <ServiceOverview class="service-overview" />
    </div>
        <div v-else class="loader">
          <RotateSquare
            class="loading-position animated fadeIn"
            size="60px"
          ></RotateSquare>
        </div>
  </section>
</template>

<script>
import {mapGetters} from "vuex"

import {Chart} from "highcharts-vue"
import ChannelServiceTime from "./components/ChannelServiceTime.vue"
import OptionsAttendanceGraphic from "./helpers/optionsAttendanceGraphic.js"
import ServiceOverview from "./components/ServiceOverview.vue"
import RotateSquare from "@/components/RotateSquare"

export default {
  name: "AttendanceGraphic",
  components: {
    ChannelServiceTime,
    highcharts: Chart,
    ServiceOverview,
    RotateSquare
  },
  data() {
    return {
      chartOptions: OptionsAttendanceGraphic,
      periode: 0,
      enviadas: [],
      recebidas: [],
      loading: false
    }
  },
  watch: {
    periode(newValue, oldValue){
      if(newValue != oldValue)
        this.LoadDataHighcharts()
    }
  },
  computed: {
    ...mapGetters({
      loadingScreen: "usuario/getLoadingScreen"
    })
  },
  beforeMount() {
    this.LoadDataHighcharts()
    // Carregar dados dos cards do gráfico
    this.$store.dispatch("dashboard/loadDataChart")
  },
  methods: {
    // Carregar dados do gráfico
    LoadDataHighcharts() {
      this.loading = true
      this.chartOptions.series = []
      this.chartOptions.xAxis.categories = []

      this.$http({
        url: `dashboard/obter-numero-atendimentos?ContaId=${this.$store.getters.getAutenticacao.contaSelecionadaId}&Periodo=${this.periode}`,
        method: "GET"
      }).then(async (resp) => {
        this.loading = false
        const { cancelados = [], emAtendimento = [], finalizados = [] } = await resp.data

        this.LoadXAxis({cancelados, emAtendimento, finalizados});

        this.LoadDataHighchartsResult(emAtendimento, "Iniciados", "#39ade3")
        this.LoadDataHighchartsResult(cancelados, "Cancelados", "#e55353")
        this.LoadDataHighchartsResult(finalizados, "Finalizados", "#2eb85c")
      })
    },

    LoadXAxis({cancelados, emAtendimento, finalizados}){
      const xAxis = []

      cancelados.forEach(atendimento => {
        if(!xAxis.find(x => x === atendimento.eixoX)){
          xAxis.push(atendimento.eixoX)
        }
      })

      emAtendimento.forEach(atendimento => {
        if(!xAxis.find(x => x === atendimento.eixoX)){
          xAxis.push(atendimento.eixoX)
        }
      })

      finalizados.forEach(atendimento => {
        if(!xAxis.find(x => x === atendimento.eixoX)){
          xAxis.push(atendimento.eixoX)
        }
      })
      this.chartOptions.xAxis.categories = xAxis.sort(function(a,b) {
        a = a.split('/').reverse().join('');
        b = b.split('/').reverse().join('');
        return a > b ? 1 : a < b ? -1 : 0;
      })
    },
    // Carregar eixos do gráfico
    LoadDataHighchartsResult(data, nameArea, colorHex){
        const dadosBar = []
        
        this.chartOptions.xAxis.categories.forEach(categorie => {
          const dataBarFound = data.find(atendimento => atendimento.eixoX === categorie)

          if(dataBarFound){
            dadosBar.push(dataBarFound.eixoY)
          }else{
            dadosBar.push(0)
          }
        })

        this.chartOptions.series.push({name: nameArea, data: dadosBar, color: colorHex})
        
    }
  }
}
</script>

<style lang="scss">
.highcharts {
  width: 100%;
  height: 95%;
}
.grafico-novo,
.loader {
  display: flex !important;
  flex-direction: row !important;
  justify-content: center;
  padding: 1rem 2rem;
  width: 100%;
}

.wrap-graphic-channel {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  margin-right: 2rem;
  width: 75%;
}

.active-control{
  background-color: #f9b115 !important;

  
      &:hover{
        background-color: #f5b938 !important;
      }
}

.wrap-control-graphic{
  width: 100%;
  height: 100%;
  position: relative;

  .controls{
    position: absolute;
    top: .1rem;
    z-index: 99;
    
    a{
      cursor: pointer;
      font-size: .8rem;
      background-color: #321fdb;
      box-shadow: 0 1px 1px 0 rgba(var(--cui-elevation-base-color,60,75,100),.14),0 2px 1px -1px rgba(var(--cui-elevation-base-color,60,75,100),.12),0 1px 3px 0 rgba(var(--cui-elevation-base-color,60,75,100),.2);
      color: #fff;
      padding: .4rem .9rem;
      border-radius: 50px;

      &:hover{
        color: #fff;
        background-color: #4735e6;
      }

      &:not(:last-child){
        margin-right: 1rem;
      }
    }
  }
}

.service-overview {
  width: 25%;
}
</style>